import Filterizr from "filterizr";

window.Grid = window.Grid || {};

window.Grid.filterizr = window.Grid.filterizr || {};

const options = {
    animationDuration: 0.6,
    easing: "ease-in-out",
    controlsSelector: ".grid",
    gridItemsSelector: ".filtr-item",
    layout: "sameSize",
    filterOutCss: {
        opacity: 0,
        transform: "scale(0.5)"
    },
    filterInCss: {
        opacity: 1,
        transform: "scale(1)"
    },
    gutterPixel: -10,
    delay: 250,
    delayMode: "alternate",
    setupControls: false
};

window.Grid.initFilterize = function () {
    const finderBtn = document.querySelector("#finderBtn");
    if (finderBtn) {
        finderBtn.classList.remove("k-disabled");
        finderBtn.removeAttribute("disabled");
    }
};

window.Grid.setupHandlers = function () {
    try {
        // init Filterize  
        window.Grid.filterizr = window.Grid.filterizr || new Filterizr(".grid", options);

        document.querySelector("#filters").addEventListener("click", (event) => {
            if (event.target.tagName === "BUTTON") {
                const buttonFilter = event.target.getAttribute("data-filter");
                const buttonSort = document.querySelector("#filtersSort.button-group button.is-checked").getAttribute("data-sort");
                let dataSort = document.querySelector("#orderType_selectId span.k-input-value-text").outerText.trim().toLowerCase();
                if (dataSort === "titolo" || dataSort === "title") {
                    dataSort = "sortData";
                }
                window.Grid.filterizr?.filter(buttonFilter);
                window.Grid.filterizr?.sort(dataSort, buttonSort);
            }
        });

        document.querySelector("#filtersSort").addEventListener("click", (event) => {
            if (event.target.tagName === "BUTTON") {
                const buttonSort = event.target.getAttribute("data-sort");
                let dataSort = document.querySelector("#orderType_selectId span.k-input-value-text").outerText.trim().toLowerCase();
                if (dataSort === "titolo" || dataSort === "title") {
                    dataSort = "sortData";
                }
                window.Grid.filterizr?.sort(dataSort, buttonSort);
            }
        });

        // use value of search field to filter
        const quicksearch = document.querySelector("#quicksearch");
        if (quicksearch) {
            quicksearch.addEventListener("keyup", debounce(() => {
                window.Grid.filterizr?.search(quicksearch.value);
            }));
        }

        // change is-checked class on buttons
        document.querySelector("#filters.button-group").style.display = "block";
        document.querySelector("#filtersSort.button-group").style.display = "block";
        document.querySelector("#orderData.order").style.display = "block";

        document.querySelectorAll("#filters.button-group").forEach((buttonGroup) => {
            buttonGroup.addEventListener("click", (event) => {
                if (event.target.tagName === "BUTTON") {
                    buttonGroup.querySelector(".is-checked").classList.remove("is-checked");
                    event.target.classList.add("is-checked");
                }
            });
        });

        document.querySelectorAll("#filtersSort.button-group").forEach((buttonGroup) => {
            buttonGroup.addEventListener("click", (event) => {
                if (event.target.tagName === "BUTTON") {
                    buttonGroup.querySelector(".is-checked").classList.remove("is-checked");
                    event.target.classList.add("is-checked");
                }
            });
        });
    } catch (e) {
        document.querySelector("#filters.button-group").style.display = "none";
        document.querySelector("#filtersSort.button-group").style.display = "none";
        document.querySelector("#orderData.order").style.display = "none";
    }

    // debounce so filtering doesn't happen every millisecond
    function debounce(fn, threshold = 100) {
        let timeout;
        return function(...args) {
            clearTimeout(timeout);
            const self = this;
            function delayed() {
                fn.apply(self, args);
            }
            timeout = setTimeout(delayed, threshold);
        };
    }
};

window.Grid.destroyFilterize = function () {
    const finderBtn = document.querySelector("#finderBtn");
    if (finderBtn) {
        finderBtn.classList.add("k-disabled");
        finderBtn.setAttribute("disabled", "disabled");
    }

    document.querySelectorAll(".button-group .is-checked").forEach((element) => {
        element.classList.remove("is-checked");
    });

    const notZeroFilter = document.querySelector('[data-filter="not-zero"]');
    if (notZeroFilter) {
        notZeroFilter.classList.add("is-checked");
        notZeroFilter.click();
    }

    const ascSort = document.querySelector('[data-sort="asc"]');
    if (ascSort) {
        ascSort.classList.add("is-checked");
        ascSort.click();
    }

    window.Grid.filterizr?.destroy();
};

window.Grid.sortByValue = function (newvalue) {
    const buttonSort = this.getAttribute("data-sort");
    if (newvalue === "titolo" || newvalue === "title") {
        newvalue = "sortData";
    }
    window.Grid.filterizr?.sort(newvalue, buttonSort);
};